module.exports = __webpack_public_path__ + "static/media/iconEmail.6f8d32bf.png";